// For ES6/ES7 support
import "core-js/stable/index.js"
import "regenerator-runtime/runtime.js"

import "bootstrap"
import "expose-loader?exposes=I18n!@app/lib/translation.js"
import "jquery-ujs"
import "@vendor/winddle/jquery.pnotify"

import FlashNotification from "@utils/flash_notification.js"

// Templates
window.Utils = { FlashNotification }
